// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupImage_wrapper__N1SbX","wrapperBlurred":"PopupImage_wrapperBlurred__C9y7j","mainImage":"PopupImage_mainImage__k87QF"};